import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { VehicleInfoService } from 'src/app/services/vehicle-info.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { CacheService } from 'src/app/services/cache.service';
import { DIMBO_CONSTANT } from 'src/app/utils/constant';

// Define date format settings
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-vehicle-info-dialog',
  templateUrl: './vehicle-info-dialog.component.html',
  styleUrls: ['./vehicle-info-dialog.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class VehicleInfoDialogComponent implements OnInit {

  vehicleinfo:any;
  maxDate = new Date();
  regdplaceholder: string;
  canceltranlation: any;
  oktranlation: any;
  isReset:boolean =false;
  constructor(private translationService: TranslateService, private vehicleInfoService:VehicleInfoService,private toastrService: ToastrService,
    public dialogRef: MatDialogRef<VehicleInfoDialogComponent>,private spinner: NgxSpinnerService,
    private cacheService: CacheService, private dateAdapter: DateAdapter<Date>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.maxDate.setDate(this.maxDate.getDate());
     // this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
     this.dateAdapter.setLocale(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL));
     }

  ngOnInit(): void {
    this.data.vehicleinfo.registrationDate = this.formatDate(this.data.vehicleinfo.registrationDate);
    this.regdplaceholder=this.translationService.instant('dimbo.i18n.label.firstRegistrationDate');
    this.canceltranlation=this.translationService.instant('dimbo.i18n.button.close');
    this.oktranlation=this.translationService.instant('dimbo.i18n.button.ok');
    this.dateAdapter.setLocale(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL));
      if(!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH)){
        this.data.vehicleinfo.mileageValue=0;
        this.data.vehicleinfo.mileageUnit=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL);
        this.isReset=true;
    }
  }
  close(): void {
    this.data.eventName = 'POPUP_CLOSE';
    this.dialogRef.close({ event: this.data });
    
  }
 

  formatDate(strDate: string): string {
    const dateAr = strDate.split('-');
    const newDateStr = dateAr[2]+'-'+dateAr[1]+'-'+dateAr[0];
    return newDateStr;
  } 
  
  checkMileageValueForWarningMessage(){
    //Logic to throw warning if user updates mileage value less than the last service  Milegage
  let lastServiceMileageValueSH=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CURRENT_MILEAGE);
  let lastServiceMileageUnitSH=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT);
  let lastServiceMileageValueVI=this.data.vehicleinfo.mileageValue;
  let lastServiceMileageUnitVI=this.data.vehicleinfo.mileageUnit;
   
  if(lastServiceMileageUnitSH=='miles'){
    //convert mileage in km
    lastServiceMileageValueSH=lastServiceMileageValueSH*1.60934;
  }
  if(lastServiceMileageUnitVI=='miles'){
    //convert mileage in km
  lastServiceMileageValueVI=lastServiceMileageValueVI*1.60934;
  }
  if(lastServiceMileageValueVI<lastServiceMileageValueSH){
    this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.mileageEditWarning'));
  }

  }

updateVehicleInfo() {
  this.checkMileageValueForWarningMessage();
  if(this.data.vehicleinfo.registrationDate) {
    this.data.vehicleinfo.registrationDate = _moment(this.data.vehicleinfo.registrationDate).format("YYYY-MM-DD");  
  }
  if (this.validateVehicleInfo(this.data.vehicleinfo.registration, this.data.vehicleinfo.registrationDate, this.data.vehicleinfo.mileageValue, this.data.vehicleinfo.mileageUnit)) {
//setting updated mileage in cache to updaet hte maintenance plan
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE, this.data.vehicleinfo.mileageValue);
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT, this.data.vehicleinfo.mileageUnit);
    
    this.spinner.show();
  // console.log('Update Vehicle Info service ');
    this.data.eventName = 'POPUP_OK';
    this.vehicleInfoService.updateVehicleInfo(this.data.vehicleinfo)
    .subscribe(response => {
     // console.log(response);
      this.vehicleinfo = response;
      this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL);
      this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH);
      this.spinner.hide();
      this.toastrService.success(this.translationService.instant('dimbo.i18n.message.VehicleInfo.vinUpdate'));
      }, error => {
        if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
          this.spinner.hide();
          this.toastrService.error(this.translationService.instant('dimbo.i18n.message.VehicleInfo.vin'));
      } else {
          this.spinner.hide();
          this.toastrService.error(this.translationService.instant('dimbo.i18n.message.record.error'), this.translationService.instant('dimbo.i18n.message.toastr.error'));
      }
       
      });
    this.spinner.hide();
    this.dialogRef.close({ event: this.data });
   }
}

validateVehicleInfo(registration, firstRegistrationDate, currentMileage, mileageUnit): boolean {
   
   // registration validation
  if (!registration) {
   // console.log('Please enter Registration Id');  
    this.toastrService.error(this.translationService.instant('dimbo.i18n.validation.registration'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
      timeOut: 5000,
    });
    return false;  
  }

  // firstRegistrationDate validation
  if (!firstRegistrationDate) {
   // console.log('pls enter registration date');  
    this.toastrService.error(this.translationService.instant('dimbo.i18n.validation.RegistrationDate'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
      timeOut: 5000,
    });
    return false;  
  }

  // currentMileage
  if (!this.isPositiveInteger(currentMileage)) {
   // console.log('pls enter valid Mileage');  
    this.toastrService.error(this.translationService.instant('dimbo.i18n.validation.CurrentMileage'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
      timeOut: 5000,
    });
    return false;
  }

  // mileageUnit validation
  if (!mileageUnit) {
   // console.log('pls enter mileageUnit ');  
    this.toastrService.error(this.translationService.instant('dimbo.i18n.validation.mileageUnit'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
      timeOut: 5000,
    });
    return false;  
  }
  
  return true;

}



isAlphabets(e: any): boolean {
  try {
        if (/^[a-zA-Z\s]*$/.test(e.key)) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
  } catch (e) {
  }
}

isPositiveInteger(n: any) {
  if(!n) {
    return false;
  } else {
    if (!n.trim()) {
      return false;
    }
  }
  return n >>> 0 === parseFloat(n);
}


}